module.exports = __webpack_public_path__ + "img/weekly-2.4173537b.png";